import React, { useState } from 'react'
import ReceivedEmailHistoryTable from './components/email-history-table'
import ReceivedTextHistoryTable from './components/txt-history-table'

const ReceivedEmailTextHistory = () => {

  const [isRefetchList, setIsRefetchList] = useState(true)
  return (
    <div className="px-20 py-10 md:px-10">
      <ReceivedEmailHistoryTable  isRefetchList={isRefetchList} setIsRefetchList={setIsRefetchList}></ReceivedEmailHistoryTable>
      <hr className="my-10 border-t-neutral-6" />
      <ReceivedTextHistoryTable  isRefetchList={isRefetchList} setIsRefetchList={setIsRefetchList}></ReceivedTextHistoryTable>
    </div>
  )
}

export default ReceivedEmailTextHistory